<div class="error-banner" *ngIf="errors.length && !isSuppressed">
  <div class="error-banner-item" *ngFor="let msg of errors; let i = index">
    <span class="error-banner-message">{{ msg }}</span>
    <button
      type="button"
      class="error-banner-close"
      (click)="dismiss(i)"
      aria-label="Dismiss error"
    >
      x
    </button>
  </div>
</div>
